export const toast = ref<ReturnType<typeof useToast>>()
export const toastErrorMessage = ref('')
